/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import SellerNavbar from "../../components/shared/sellernavbar/SellerNavbar";
import {
  getSellerProfileByIdRecord,
  getShopDetailsBySellerIdRecord,
} from "../../store/actions/sellerProfileAction";
import authenticationService from "../../store/services/authenticationService";
import sellerService from "../../store/services/sellerService";
import { removeLocalStorageAdmin } from "../../utils/Functions/removeLocalStorageAdmin";

const SellerNavBarContainer = () => {
  const dispatch = useDispatch();
  let history = useHistory();

  const { sellerProfileById, error } = useSelector(
    (state) => state.sellerProfileReducer,
  );

  React.useEffect(() => {
    let userId = sellerService.getEmployeeId();
    let roleId = authenticationService.getRoleId();

    if (roleId !== "2") {
      removeLocalStorageAdmin();
      history?.push("/sellerLogin");
    }

    dispatch(getSellerProfileByIdRecord(userId));
    dispatch(getShopDetailsBySellerIdRecord(userId));
  }, [dispatch, history]);

  React.useEffect(() => {
    if (error && sellerProfileById?.length === 0) {
      removeLocalStorageAdmin();
      history?.push("/sellerLogin");
    }
  }, [sellerProfileById, error]);

  return (
    <div id="wrapper">
      <SellerNavbar key="Navbar" sellerProfileById={sellerProfileById} />
    </div>
  );
};

export default SellerNavBarContainer;
